export const PRICE_MAX_INT_DIGITS = 9;
export const PRICE_MAX_FRAC_DIGITS = 2;

export const stripSpaces = (text: string): string => text.replace(/\s/g, '');

export const groupPrice = (text: string): string => {
    const clean = stripSpaces(text);
    const sep = clean.search(/[.,]/);
    const intPart = (sep === -1 ? clean : clean.slice(0, sep))
        .replace(/\D/g, '')
        .replace(/^0+(?=\d)/, '')
        .slice(0, PRICE_MAX_INT_DIGITS);
    const fracPart =
        sep === -1
            ? ''
            : `,${clean.slice(sep + 1).replace(/\D/g, '').slice(0, PRICE_MAX_FRAC_DIGITS)}`;

    return intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') + fracPart;
};

export const groupInt = (value: number): string =>
    value ? value.toLocaleString('ru-RU') : '';

export const digitsOf = (value: string): number =>
    Number(value.replace(/\D/g, '').slice(0, PRICE_MAX_INT_DIGITS)) || 0;

export const countBeforeCaret = (input: HTMLInputElement): number => {
    const caret = input.selectionStart ?? input.value.length;
    return input.value.slice(0, caret).replace(/[^\d.,]/g, '').length;
};

export const caretAfter = (text: string, count: number): number => {
    if (!count) return 0;
    let seen = 0;
    for (let i = 0; i < text.length; i += 1) {
        if (/[\d.,]/.test(text[i])) {
            seen += 1;
            if (seen === count) return i + 1;
        }
    }
    return text.length;
};

export const restoreCaret = (input: HTMLInputElement, count: number): void => {
    const pos = caretAfter(input.value, count);
    input.setSelectionRange(pos, pos);
};

const GROUP_SPACE = /[\u00a0\u202f]/g;

const groupDigits = (digits: string): string =>
    digits
        .slice(0, PRICE_MAX_INT_DIGITS)
        .replace(/^0+(?=\d)/, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');

export const groupNumbersInText = (text: string): string =>
    text.replace(GROUP_SPACE, '').replace(/\d+/g, groupDigits);

export const countCharsBeforeCaret = (input: HTMLInputElement): number => {
    const caret = input.selectionStart ?? input.value.length;
    return input.value.slice(0, caret).replace(GROUP_SPACE, '').length;
};

export const restoreCaretByChars = (input: HTMLInputElement, count: number): void => {
    let seen = 0;
    let pos = 0;
    while (pos < input.value.length && seen < count) {
        if (!/[\u00a0\u202f]/.test(input.value[pos])) seen += 1;
        pos += 1;
    }
    input.setSelectionRange(pos, pos);
};